<template>
  <div>
    <vue-recaptcha
      :sitekey="sitekey"
      :loadRecaptchaScript="true"
      @verify="onCaptchaVerified"
      @expired="onCaptchaExpired"
      ref="recaptcha"
    ></vue-recaptcha>
    <v-input
        v-if="isShowMessage"
        :error-messages="errorText"
      >
    </v-input>
    <v-btn
      color="primary"
      @click="$emit('onSubmit')"
      width="130"
      class="rounded-lg my-5"
      :disabled="!isValidateRecaptcha"
    >
      <translate>Send</translate>
      <icon v-if="isValidateRecaptcha" name="icon-circle-arrow" width="20" height="20" class="ml-4"/>
      <icon v-else name="icon-circel-arrow-default" width="20" height="20" class="ml-4"/>
    </v-btn>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: "ReCaptchaSubmit",
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      errorText: this.$gettext("Le captcha de vérification est obligatoire"),
      sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      isValidateRecaptcha: false,
      isShowMessage: false,
    };
  },
  computed: {},
  watch: {
    isValidateRecaptcha() {
      if (this.isValidateRecaptcha == true) {
        this.isShowMessage = false;
      }
    }
  },
  methods: {
    onCaptchaVerified(response) {
      this.isValidateRecaptcha = true;
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>
